const clients = [
  {
    id: 1,
    name: 'Ercison',
    notes: 'first client...',
    accounts: [1, 2],
    warehouses: [1, 2],
  },
  {
    id: 2,
    name: 'Huawei',
    notes: 'second client...',
    accounts: [3, 4, 9],
    warehouses: [3, 4],
  },
  {
    id: 3,
    name: 'Orascom',
    notes: 'client with same account',
    accounts: [5],
    warehouses: [5],
  },
];

const accounts = [
  {
    id: 1,
    client_id: 1,
    name: 'Etisalat',
    projects: [1, 2],
  },
  {
    id: 2,
    client_id: 1,
    name: 'Vodafone',
    projects: [3, 4],
  },
  {
    id: 3,
    client_id: 2,
    name: 'WE',
    projects: [5, 6],
  },
  {
    id: 4,
    client_id: 2,
    name: 'Orange',
    projects: [7, 8],
  },
  {
    id: 5,
    client_id: 3,
    name: 'Orascom',
    projects: [9],
  },
];

const projects = [
  {
    id: 1,
    account_id: 1,
    name: 'West Cairo',
    coordinator_name: 'Ahmed Yehia',
  },
  {
    id: 2,
    account_id: 1,
    name: 'Abu Qir',
    coordinator_name: 'Mohamed Fawzy',
  },
  {
    id: 3,
    account_id: 2,
    name: 'Mostrod',
    coordinator_name: 'Omar Ayman',
  },
  {
    id: 4,
    account_id: 2,
    name: 'Ramses Station',
    coordinator_name: 'Ali Medhat',
  },
  {
    id: 5,
    account_id: 3,
    name: 'North Capital',
    coordinator_name: 'Radman Gamal',
  },
  {
    id: 6,
    account_id: 3,
    name: 'Abu Sannan',
    coordinator_name: 'Michael Emad',
  },
  {
    id: 7,
    account_id: 4,
    name: 'Benban',
    coordinator_name: 'Ahmed Khalifa',
  },
  {
    id: 8,
    account_id: 4,
    name: 'Mariout',
    coordinator_name: 'Hossam Abdullah',
  },
  {
    id: 9,
    account_id: 5,
    name: 'Orascom project',
    coordinator_name: 'Hossam Abdullah',
  },
];

const warehouses = [
  {
    id: 1,
    client_id: 1,
    name: 'Alex warehouse',
  },
  {
    id: 2,
    client_id: 1,
    name: 'Cairo warehouse',
  },
  {
    id: 3,
    client_id: 2,
    name: 'Alex warehouse',
  },
  {
    id: 4,
    client_id: 2,
    name: 'Aswan warehouse',
  },
  {
    id: 5,
    client_id: 3,
    name: 'Giza warehouse',
  },
];

const id = {
  clients: (clients[clients.length -1] || {id: 0}).id,
  accounts: (accounts[accounts.length -1] || {id: 0}).id,
  projects: (projects[projects.length -1] || {id: 0}).id,
  warehouses: (warehouses[warehouses.length -1] || {id: 0}).id,
};

const new_id = (table) => ++id[table];

export default {
  clients,
  accounts,
  projects,
  warehouses,
  id,
  new_id,
}
